var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('van-row',{attrs:{"gutter":"20"}},[(!_vm.withOutLeftSide)?_c('van-col',{staticClass:"pos-sticky",attrs:{"span":"8"}},[_c('CategoryList')],1):_vm._e(),_c('van-col',{attrs:{"span":_vm.withOutLeftSide ? 24 : 12}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }